import React, { useEffect, useState, useCallback } from "react";
import ActivityIndicator from "../components/ActivityIndicator";
import configurationPost from "../config/configurationPost";
import connectionConfig from "../config/settings";
//import consoleLog from "../utility/consoleLog";
import { View, StyleSheet, Image, FlatList, Alert, TouchableOpacity, Text } from 'react-native';
import routes from "../navigation/routes";
import { useFocusEffect } from '@react-navigation/native';
import { Video, AVPlaybackStatus } from 'expo-av';
import { Foundation } from "@expo/vector-icons";
import colors from "../config/colors";

var pointer = 0
var blockSize = 10
var pageNumber = 0
var arraySeeds = []
var webUrl = connectionConfig.imageUrl + '/seedImages/'
var seedVideoUri = connectionConfig.imageUrl + '/Documents/videoSeeds/'


function MosaicOfSeedsScreen(props) {
  //function MosaicOfSeedsScreen({navigation, userId}) {
  const [seedsSucces, setSeedsSucces] = useState(false);
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const video = React.useRef(null);
  const [status, setStatus] = useState({});
  var foundUserChecker = props.foundUserChecker;


  useFocusEffect(
    useCallback(() => {
      pageNumber = 0
      arraySeeds = []
      getSeeds();
    }, [])    // [props.userId]
  );

  const getSeeds = async () => {
    //debugger
    pointer = pageNumber * blockSize
    setLoading(true)
    var post_values = {
      //userId : userId
      userId: props.userId,
      pointer: pointer,
      blockSize: blockSize
    }
    //establece parámetros de configurción del post
    configurationPost.body = JSON.stringify(post_values)
    //solicita el servicio para adquirir los pubicaciones del servidor
    await fetch(connectionConfig.apiUrl + '/selectMosaicSeed/', configurationPost)
      .then(response => response.json())
      .then(response => {
        //if(response.data.length === 0)
        if (response.data.length === 0) {
          if (pageNumber > 0) {
            setLoading(false)
          } else {
            setSeedsSucces(false)
            setLoading(false)
          }
        } else {
          pageNumber++
          if (arraySeeds.length > 0) {
            arraySeeds = [...arraySeeds, ...response.data]
            //arraySeeds = [ ...arraySeeds, ...response]
          } else {
            arraySeeds = response.data
            //arraySeeds = response
          }
          setItems(arraySeeds)
          setLoading(false)
          setSeedsSucces(true)
        }
      })
      .catch(err => {
        console.log('getSeeds failed :( review internet service)', err)
      })
  }

  return (
    <>
      <ActivityIndicator visible={loading} />
      {seedsSucces ?
        <FlatList
          style={styles.imageContainer}
          data={items}
          keyExtractor={(item) => item.seedId.toString()}
          //key={String(items.seedId)}
          //keyExtractor={item => String(item.seedId) }
          numColumns={3}
          initialNumToRender={items.length}
          //onEndReachedThreshold={-0.5}
          onEndReachedThreshold={.5}
          onEndReached={() => getSeeds()}
          renderItem={({ item, index }) => (
            <TouchableOpacity onPress={() => {
              var userId = props.userId
              props.navigation.navigate(routes.LISTINGS_SEEDS, {
                items,
                index,
                pointer,
                blockSize,
                pageNumber,
                foundUserChecker,
                userId
              })

            }}  >
              {item.seedPhoto.includes('.mp4') ?
                <Video
                  ref={video}
                  style={item.type === 0 ? styles.image :
                    item.type === 1 ? styles.image1 :
                      item.type === 2 ? styles.image2 :
                        item.type === 3 ? styles.image3 :
                          item.type === 4 ? styles.image4 :
                            item.type === 5 ? styles.image5 :
                              item.type === 6 ? styles.image6 :
                                item.type === 7 ? styles.image7 :
                                  item.type === 8 ? styles.image8 :
                                    styles.image9
                  }
                  source={{
                    uri: seedVideoUri + item.seedPhoto
                  }}
                  //useNativeControls
                  resizeMode="contain"
                //isLooping
                //onPlaybackStatusUpdate = {status => setStatus(() => status)}
                />
                :
                item.seedPhoto.includes('.mov') ?
                  <Video
                    ref={video}
                    style={item.type === 0 ? styles.image :
                      item.type === 1 ? styles.image1 :
                        item.type === 2 ? styles.image2 :
                          item.type === 3 ? styles.image3 :
                            item.type === 4 ? styles.image4 :
                              item.type === 5 ? styles.image5 :
                                item.type === 6 ? styles.image6 :
                                  item.type === 7 ? styles.image7 :
                                    item.type === 8 ? styles.image8 :
                                      styles.image9
                    }
                    source={{
                      uri: seedVideoUri + item.seedPhoto
                    }}
                    //useNativeControls
                    resizeMode="contain"
                  //isLooping
                  //onPlaybackStatusUpdate = {status => setStatus(() => status)}
                  />
                  :
                  item.seedPhoto === '' ?
                    <Foundation //style={styles.image}
                      style={item.type === 0 ? styles.image :
                        item.type === 1 ? styles.image1 :
                          item.type === 2 ? styles.image2 :
                            item.type === 3 ? styles.image3 :
                              item.type === 4 ? styles.image4 :
                                item.type === 5 ? styles.image5 :
                                  item.type === 6 ? styles.image6 :
                                    item.type === 7 ? styles.image7 :
                                      item.type === 8 ? styles.image8 :
                                        styles.image9
                      }
                      name="mountains"
                      size={120}
                      color={colors.medium} />
                    :
                    <Image
                      //debugger
                      //style= {styles.image}
                      style={item.type === 0 ? styles.image :
                        item.type === 1 ? styles.image1 :
                          item.type === 2 ? styles.image2 :
                            item.type === 3 ? styles.image3 :
                              item.type === 4 ? styles.image4 :
                                item.type === 5 ? styles.image5 :
                                  item.type === 6 ? styles.image6 :
                                    item.type === 7 ? styles.image7 :
                                      item.type === 8 ? styles.image8 :
                                        styles.image9
                      }
                      source={{ uri: webUrl + item.seedPhoto }}
                    />
              }
            </TouchableOpacity>
          )}
        />
        :
        <Text>This user has not seeds yet.  :) </Text>
      }
    </>
  );
}

const styles = StyleSheet.create({
  imageContainer: {
   // marginVertical: '2%',
    marginLeft: '2%',
    alignContent: 'center',
    width: '100%',
    height: '100%',
  },
  container: {

  },
  image: {
    margin: "0.5%",
    width: 120,
    height: 120,
    borderWidth: 4,
    borderColor: colors.chakra0red,
    //borderBottomWidth: 4,
  },
  image1: {
    margin: "0.5%",
    width: 120,
    height: 120,
    borderWidth: 4,
    borderColor: colors.chakra1nar,
    //borderBottomWidth: 4,
  },
  image2: {
    margin: "0.5%",
    width: 120,
    height: 120,
    borderWidth: 4,
    borderColor: colors.chakra2ama,
    //borderBottomWidth: 4,
  },
  image3: {
    margin: "0.5%",
    width: 120,
    height: 120,
    borderWidth: 4,
    borderColor: colors.chakra3ver
  },
  image4: {
    margin: "0.5%",
    width: 120,
    height: 120,
    borderWidth: 4,
    borderColor: colors.chakra4azu
  },
  image5: {
    margin: "0.5%",
    width: 120,
    height: 120,
    borderWidth: 4,
    borderColor: colors.chakra5vlt
  },
  image6: {
    margin: "0.5%",
    width: 120,
    height: 120,
    borderWidth: 4,
    borderColor: colors.chakra6rsa
  },
  image7: {
    margin: "0.5%",
    width: 120,
    height: 120,
    borderWidth: 4,
    borderColor: colors.chakra7ryo
  },
  image8: {
    margin: "0.5%",
    width: 120,
    height: 120,
    borderWidth: 4,
    borderColor: colors.chakra8tur
  },
  image9: {
    margin: "0.5%",
    width: 120,
    height: 120,
    borderWidth: 4,
    borderColor: colors.chakra9aur
  },
})

export default MosaicOfSeedsScreen;